export class CSPReport {
    constructor() { }

    CSPReportID: number;
    JurisID: number;
    FileName: string;
    CustomJobName: string;
    FolderPath: string;
    ReportXML: string;
    CreatedPFID: number;
    CreatedDttmUTC: Date;
    ModifiedPFID: number;
    ModifiedDttmUTC: Date;
    Custom1: string;
    Custom2: string;
    SourceID: number;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/cspreport.model.ts